import { AfterViewInit, Component, OnInit, ViewChild  } from '@angular/core';
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { Invitation } from '../../models/invitation.model';
import { UsersService } from '../../services/users.service';
import { User } from '../../models/user.model';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ModalUserInvitationComponent } from '../modal-user-invitation/modal-user-invitation.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { getPolishPaginatorIntl } from '../../polish-paginator-intl';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Component({
  selector: 'app-user-invitation-list',
  standalone: true,
  imports: [
    MatTableModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatPaginatorModule,
    MatCardModule,
    MatSortModule
  ],
  templateUrl: './user-invitation-list.component.html',
  styleUrl: './user-invitation-list.component.css',
  providers: [{ provide: MatPaginatorIntl, useValue: getPolishPaginatorIntl() }]
})
export class UserInvitationListComponent implements OnInit, AfterViewInit{

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  invitations: Invitation[] = [];

  dataSource: MatTableDataSource<Invitation> = new MatTableDataSource<Invitation>();

  public displayedColumns: string[] = [
    'email',
    'role',
    'status',
    'expires_at',
    'created_at',
    'inviter',
    'actions'
  ];

  constructor(
    private usersService: UsersService,
    readonly dialog: MatDialog,
    private router: Router,
    private snackBar: MatSnackBar
  ){

  }
  
  private snackbarConfig: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'top',
    duration: 5000,
  };

  ngOnInit(): void {
    this.fetchInvitations();

  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  doFilter(value: String) {
    this.dataSource.filter = value.trim().toLowerCase()
  }

  fetchInvitations(){
    this.usersService.getInvitationList("pending",1,15)
    .subscribe({
      next: (response: any) => {
        this.invitations = response.data.data.map((el: any) => {
          return new Invitation(
            Number(el.id), 
            el.email,
            el.role,
            el.status,
            el.expires_at,
            el.created_at,
            new User(el.inviter.id,el.inviter.email,el.inviter.name,el.inviter.surname,el.inviter.is_admin)
          )
        });

        this.dataSource.data = this.invitations;

        this.dataSource.filterPredicate = (data: Invitation, filter: string) => {
            return data.email.includes(filter)
          };

      },
      error: (error) => {
        if(error.status === 401) {
          this.router.navigate(['/']);   
        }
        console.error(error);
      }
    });
  }

  openModal() {
       const dialogRef = this.dialog.open(ModalUserInvitationComponent, {
        height: '300px', 
        position: {
          top: '5%'
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Dialog closed with result:', result);
          this.fetchInvitations();
        } else {
          console.log('Dialog was dismissed');
        }
      });
    };

  openUserList() {
    this.router.navigate(['users-list'])
  }

  invitationDetails(id: number) {
    this.router.navigate(['invitation/' + id])
  }

  onResendInvitation(id: number, email: string) {
    console.log("refresh ", id);
    
    this.usersService.resendInvitation(id).subscribe({
      next: (res) => {
        this.snackBar.open('Wysłano ponownie zaproszenie do: ' + email, 'OK', this.snackbarConfig);
        this.fetchInvitations();
      },
      error: (err) => {
        switch(err.status){
          case 404:
            this.snackBar.open('Zaproszenie nie istnieje', 'OK', this.snackbarConfig);
            break;
          case 400: 
            this.snackBar.open('Zaproszenie już wykorzystane lub anulowane', 'OK', this.snackbarConfig);
            break;
          default:
            this.snackBar.open('Coś poszło nie tak', 'OK', this.snackbarConfig);
            console.error(err);
        }
      }
    })
  }

  onCancelInvitation(id: number, email:string) {
    if (confirm("Czy na pewno usunąć zaproszenie do " + email + "?")) {
    
      this.usersService.cancelInvitation(id).subscribe({
        next: (res) => {
          this.snackBar.open('Usunięto zaproszenie do: ' + email, 'OK', this.snackbarConfig);
          this.fetchInvitations();
        },
        error: (err) => {
          switch(err.status) {
            case 404:
              this.snackBar.open('Zaproszenie nie istnieje', 'OK', this.snackbarConfig);
              break;
            case 400: 
              this.snackBar.open('Zaproszenie już wykorzystane lub anulowane', 'OK', this.snackbarConfig);
              break;
            default:
              this.snackBar.open('Coś poszło nie tak', 'OK', this.snackbarConfig);
              console.error(err); 
          }
        }
      })
    }
  }
}
